import {
	SHOW_SNACKBAR,
	HIDE_SNACKBAR
} from '../actions/snackbar.js';

const initialState = {
	snackbarMessage: null,
	snackbarOpen: false,
	snackbarDuration: 4000,
	snackbarAction: null,
	snackbarSeverity: null
}

export default function snackbar (state = {}, action) {
	switch (action.type) {
		case SHOW_SNACKBAR:
			return action.payload === null
				? {}
				: {
						...state,
						snackbarOpen: true,
						snackbarMessage: action.message ? action.message : action.snackMessage,
						snackbarDuration: action.duration ? action.duration : initialState.snackbarDuration,
						snackbarAction: action.action ? action.action : (action.button ? action.button : initialState.snackbarAction),
						snackbarSeverity: action.severity ? action.severity : initialState.snackbarSeverity
				}
		case HIDE_SNACKBAR: 
			return action.payload === null
				? {}
				: {
						...state,
						snackbarOpen: false
				}
		default:
			return state
	}
}


// WEBPACK FOOTER //
// ./src/reducers/snackbar.js